 import { styled } from "@mui/material/styles";

 const StyledStatusTag = styled("div")(
   ({ theme }) => `
   .status-tag {
    padding: 2px 6px;
    border-radius: 24px;
    width: fit-content;
   }
   .status-tag-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 11px;
    font-style: normal;
    line-height: 100%;
    text-transform: lowercase;
    &::first-letter {
      text-transform: uppercase;
    }
   } 
`
 );

 export default StyledStatusTag;
